export const SEND_REQUEST_BEGIN = 'SEND_REQUEST_BEGIN'
export const SEND_REQUEST_END = 'SEND_REQUEST_END'
export const SEND_REQUEST_SUCCESS = 'SEND_REQUEST_SUCCESS'
export const CONACTUS_REQUEST_BEGIN = 'CONACTUS_REQUEST_BEGIN'
export const CONACTUS_REQUEST_END = 'CONACTUS_REQUEST_END'
export const NOTIFY_REQUEST_BEGIN = 'NOTIFY_REQUEST_BEGIN'
export const NOTIFY_REQUEST_END = 'NOTIFY_REQUEST_END'

